import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
};

export type Category = {
  __typename?: 'Category';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CategoryInput = {
  name: Scalars['String']['input'];
};

export type CategoryUpdateInput = {
  name: Scalars['String']['input'];
};

export type CompanyDetail = {
  __typename?: 'CompanyDetail';
  about?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyCreationDate?: Maybe<Scalars['String']['output']>;
  companySize?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type CompanyDetailInput = {
  city: Scalars['String']['input'];
  companyCreationDate?: InputMaybe<Scalars['String']['input']>;
  companySize: Scalars['String']['input'];
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  website: Scalars['String']['input'];
};

export type ContactInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  message: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export enum EmploymentType {
  Contract = 'CONTRACT',
  FullTime = 'FULL_TIME',
  Internship = 'INTERNSHIP',
  Other = 'OTHER',
  PartTime = 'PART_TIME',
  PerDiem = 'PER_DIEM',
  Temporary = 'TEMPORARY',
  Volunteer = 'VOLUNTEER'
}

export type Job = {
  __typename?: 'Job';
  description: Scalars['String']['output'];
  educationRequired?: Maybe<Scalars['String']['output']>;
  employmentType: EmploymentType;
  experienceRequired: Scalars['Int']['output'];
  expirationDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  location: Scalars['String']['output'];
  postedDate: Scalars['String']['output'];
  salaryMax: Scalars['Int']['output'];
  salaryMin: Scalars['Int']['output'];
  skillsRequired?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
};

export type JobInput = {
  description: Scalars['String']['input'];
  educationRequired?: InputMaybe<Scalars['String']['input']>;
  employmentType: EmploymentType;
  experienceRequired: Scalars['Int']['input'];
  expirationDate: Scalars['DateTime']['input'];
  location: Scalars['String']['input'];
  postedDate: Scalars['String']['input'];
  salaryMax: Scalars['Int']['input'];
  salaryMin: Scalars['Int']['input'];
  skillsRequired?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
};

export enum JobStatus {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  OnHold = 'ON_HOLD',
  Open = 'OPEN',
  PendingApproval = 'PENDING_APPROVAL'
}

export type JobUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  educationRequired?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<EmploymentType>;
  experienceRequired?: InputMaybe<Scalars['Int']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  postedDate?: InputMaybe<Scalars['String']['input']>;
  salaryMax?: InputMaybe<Scalars['Int']['input']>;
  salaryMin?: InputMaybe<Scalars['Int']['input']>;
  skillsRequired?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addUserEducation: UserEducation;
  addUserEmployment: UserEmployment;
  addUserSkill: UserSkill;
  blockUser: Scalars['Boolean']['output'];
  changeJobStatus: Job;
  createCategory: Category;
  createJob: Job;
  deleteUser: Scalars['Boolean']['output'];
  register: Session;
  removeUserEducation: Scalars['Boolean']['output'];
  removeUserEmployment: Scalars['Boolean']['output'];
  removeUserSkill: Scalars['Boolean']['output'];
  requestPasswordReset: Scalars['Boolean']['output'];
  resetPassword: Scalars['Boolean']['output'];
  unLockUser: Scalars['Boolean']['output'];
  updateCategory: Scalars['Boolean']['output'];
  updateCompanyDetail: User;
  updateJob: Job;
  updatePersonalDetails: Scalars['Boolean']['output'];
  updateUserEducation: Scalars['Boolean']['output'];
  updateUserEmployment: Scalars['Boolean']['output'];
  updateUserResume: User;
  updateUserRole: Scalars['Boolean']['output'];
  updateUserSkill: Scalars['Boolean']['output'];
};


export type MutationAddUserEducationArgs = {
  education: UserEducationInput;
};


export type MutationAddUserEmploymentArgs = {
  employment: UserEmploymentInput;
};


export type MutationAddUserSkillArgs = {
  skill: UserSkillInput;
};


export type MutationBlockUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationChangeJobStatusArgs = {
  jobId: Scalars['ID']['input'];
  status: JobStatus;
};


export type MutationCreateCategoryArgs = {
  categoryInput: CategoryInput;
};


export type MutationCreateJobArgs = {
  jobInput: JobInput;
};


export type MutationDeleteUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationRegisterArgs = {
  registerInput: RegisterInput;
};


export type MutationRemoveUserEducationArgs = {
  educationId: Scalars['ID']['input'];
};


export type MutationRemoveUserEmploymentArgs = {
  employmentId: Scalars['ID']['input'];
};


export type MutationRemoveUserSkillArgs = {
  skillId: Scalars['ID']['input'];
};


export type MutationRequestPasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  resetPasswordInput: ResetPasswordInput;
};


export type MutationUnLockUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationUpdateCategoryArgs = {
  categoryId: Scalars['ID']['input'];
  categoryInput: CategoryUpdateInput;
};


export type MutationUpdateCompanyDetailArgs = {
  companyDetailInput: CompanyDetailInput;
};


export type MutationUpdateJobArgs = {
  jobId: Scalars['ID']['input'];
  jobInput: JobUpdateInput;
};


export type MutationUpdatePersonalDetailsArgs = {
  personalDetailsInput: PersonalDetailsInput;
};


export type MutationUpdateUserEducationArgs = {
  education: UserEducationUpdateInput;
  educationId: Scalars['ID']['input'];
};


export type MutationUpdateUserEmploymentArgs = {
  employment: UserEmploymentUpdateInput;
  employmentId: Scalars['ID']['input'];
};


export type MutationUpdateUserResumeArgs = {
  about: Scalars['String']['input'];
};


export type MutationUpdateUserRoleArgs = {
  role: UserRole;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateUserSkillArgs = {
  skill: UserSkillUpdateInput;
  skillId: Scalars['ID']['input'];
};

export type PersonalDetailsInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  fetchCategories: Array<Category>;
  fetchCategory: Category;
  fetchCurrentUser: User;
  fetchJobs: Array<Job>;
  fetchMyJob: Job;
  fetchMyJobs: Array<Job>;
  fetchPremiumJobs: Array<Job>;
  fetchUserEducation: UserEducation;
  fetchUserEducations: Array<UserEducation>;
  fetchUserEmployment: UserEmployment;
  fetchUserEmployments: Array<UserEmployment>;
  fetchUserSkill: UserSkill;
  fetchUserSkills: Array<UserSkill>;
  fetchUsers: Array<User>;
  login: Session;
  sendContactMessage: Scalars['Boolean']['output'];
};


export type QueryFetchCategoryArgs = {
  categoryId: Scalars['ID']['input'];
};


export type QueryFetchMyJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryFetchUserEducationArgs = {
  userEducationId: Scalars['ID']['input'];
};


export type QueryFetchUserEmploymentArgs = {
  userEmploymentId: Scalars['ID']['input'];
};


export type QueryFetchUserSkillArgs = {
  userSkillId: Scalars['ID']['input'];
};


export type QueryLoginArgs = {
  loginInput: LoginInput;
};


export type QuerySendContactMessageArgs = {
  contactInput: ContactInput;
};

export type RegisterInput = {
  asRecruiter?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ResetPasswordInput = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type Session = {
  __typename?: 'Session';
  token: Scalars['String']['output'];
  user: User;
};

export type User = {
  __typename?: 'User';
  about?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CompanyDetail>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  educations?: Maybe<Array<UserEducation>>;
  email: Scalars['String']['output'];
  employments?: Maybe<Array<UserEmployment>>;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  nationality?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  role: UserRole;
  skills?: Maybe<Array<UserSkill>>;
  status: UserStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type UserEducation = {
  __typename?: 'UserEducation';
  endDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  level: Scalars['String']['output'];
  school: Scalars['String']['output'];
  specialization: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type UserEducationInput = {
  endDate: Scalars['DateTime']['input'];
  level: Scalars['String']['input'];
  school: Scalars['String']['input'];
  specialization: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type UserEducationUpdateInput = {
  endDate: Scalars['DateTime']['input'];
  level: Scalars['String']['input'];
  school: Scalars['String']['input'];
  specialization: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type UserEmployment = {
  __typename?: 'UserEmployment';
  city: Scalars['String']['output'];
  company: Scalars['String']['output'];
  country: Scalars['String']['output'];
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCurrentPosition: Scalars['Boolean']['output'];
  jobTitle: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type UserEmploymentInput = {
  city: Scalars['String']['input'];
  company: Scalars['String']['input'];
  country: Scalars['String']['input'];
  description: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isCurrentPosition?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type UserEmploymentUpdateInput = {
  city: Scalars['String']['input'];
  company: Scalars['String']['input'];
  country: Scalars['String']['input'];
  description: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isCurrentPosition: Scalars['Boolean']['input'];
  jobTitle: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};

/** Possible user role */
export enum UserRole {
  Admin = 'ADMIN',
  Instructor = 'INSTRUCTOR',
  Recruiter = 'RECRUITER',
  Talent = 'TALENT'
}

export type UserSkill = {
  __typename?: 'UserSkill';
  id: Scalars['ID']['output'];
  proficiency: Scalars['String']['output'];
  skill: Scalars['String']['output'];
};

export type UserSkillInput = {
  proficiency: Scalars['String']['input'];
  skill: Scalars['String']['input'];
};

export type UserSkillUpdateInput = {
  proficiency: Scalars['String']['input'];
  skill: Scalars['String']['input'];
};

/** Possible user status */
export enum UserStatus {
  Blocked = 'Blocked',
  Joined = 'Joined',
  Pending = 'Pending'
}

export type RegisterMutationVariables = Exact<{
  registerInput: RegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'Session', token: string, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, phone?: string | null, role: UserRole } } };

export type LoginQueryVariables = Exact<{
  loginInput: LoginInput;
}>;


export type LoginQuery = { __typename?: 'Query', login: { __typename?: 'Session', token: string, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, phone?: string | null, role: UserRole } } };

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset: boolean };

export type ResetPasswordMutationVariables = Exact<{
  resetPasswordInput: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type SendContactMessageQueryVariables = Exact<{
  contactInput: ContactInput;
}>;


export type SendContactMessageQuery = { __typename?: 'Query', sendContactMessage: boolean };

export type FetchCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchCurrentUserQuery = { __typename?: 'Query', fetchCurrentUser: { __typename?: 'User', email: string, firstName: string, lastName: string, fullName: string, phone?: string | null, address?: string | null, country?: string | null, nationality?: string | null, gender?: string | null, city?: string | null, avatar?: string | null, about?: string | null, employments?: Array<{ __typename?: 'UserEmployment', id: string, jobTitle: string, company: string, description: string, country: string, city: string, startDate: string, endDate?: string | null, isCurrentPosition: boolean }> | null, educations?: Array<{ __typename?: 'UserEducation', id: string, school: string, level: string, specialization: string, startDate: string, endDate: string }> | null, skills?: Array<{ __typename?: 'UserSkill', id: string, skill: string, proficiency: string }> | null, company?: { __typename?: 'CompanyDetail', phone?: string | null, name?: string | null, companySize?: string | null, companyCreationDate?: string | null, website?: string | null, country?: string | null, city?: string | null, about?: string | null } | null } };

export type UpdateUserResumeMutationVariables = Exact<{
  about: Scalars['String']['input'];
}>;


export type UpdateUserResumeMutation = { __typename?: 'Mutation', updateUserResume: { __typename?: 'User', about?: string | null, company?: { __typename?: 'CompanyDetail', about?: string | null } | null } };

export type UpdatePersonalDetailsMutationVariables = Exact<{
  personalDetailsInput: PersonalDetailsInput;
}>;


export type UpdatePersonalDetailsMutation = { __typename?: 'Mutation', updatePersonalDetails: boolean };

export type AddUserEducationMutationVariables = Exact<{
  education: UserEducationInput;
}>;


export type AddUserEducationMutation = { __typename?: 'Mutation', addUserEducation: { __typename?: 'UserEducation', id: string, school: string, level: string, specialization: string, startDate: string, endDate: string } };

export type UpdateUserEducationMutationVariables = Exact<{
  education: UserEducationUpdateInput;
  educationId: Scalars['ID']['input'];
}>;


export type UpdateUserEducationMutation = { __typename?: 'Mutation', updateUserEducation: boolean };

export type RemoveUserEducationMutationVariables = Exact<{
  educationId: Scalars['ID']['input'];
}>;


export type RemoveUserEducationMutation = { __typename?: 'Mutation', removeUserEducation: boolean };

export type AddUserEmploymentMutationVariables = Exact<{
  employment: UserEmploymentInput;
}>;


export type AddUserEmploymentMutation = { __typename?: 'Mutation', addUserEmployment: { __typename?: 'UserEmployment', id: string, jobTitle: string, company: string, description: string, country: string, city: string, startDate: string, endDate?: string | null, isCurrentPosition: boolean } };

export type UpdateUserEmploymentMutationVariables = Exact<{
  employment: UserEmploymentUpdateInput;
  employmentId: Scalars['ID']['input'];
}>;


export type UpdateUserEmploymentMutation = { __typename?: 'Mutation', updateUserEmployment: boolean };

export type RemoveUserEmploymentMutationVariables = Exact<{
  employmentId: Scalars['ID']['input'];
}>;


export type RemoveUserEmploymentMutation = { __typename?: 'Mutation', removeUserEmployment: boolean };

export type AddUserSkillMutationVariables = Exact<{
  skill: UserSkillInput;
}>;


export type AddUserSkillMutation = { __typename?: 'Mutation', addUserSkill: { __typename?: 'UserSkill', id: string, skill: string, proficiency: string } };

export type UpdateUserSkillMutationVariables = Exact<{
  skill: UserSkillUpdateInput;
  skillId: Scalars['ID']['input'];
}>;


export type UpdateUserSkillMutation = { __typename?: 'Mutation', updateUserSkill: boolean };

export type RemoveUserSkillMutationVariables = Exact<{
  skillId: Scalars['ID']['input'];
}>;


export type RemoveUserSkillMutation = { __typename?: 'Mutation', removeUserSkill: boolean };

export type FetchJobsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchJobsQuery = { __typename?: 'Query', fetchJobs: Array<{ __typename?: 'Job', id: string, title: string, description: string, salaryMin: number, salaryMax: number, location: string, experienceRequired: number, educationRequired?: string | null, employmentType: EmploymentType, postedDate: string, expirationDate: any, skillsRequired?: Array<string> | null }> };

export type FetchMyJobsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchMyJobsQuery = { __typename?: 'Query', fetchMyJobs: Array<{ __typename?: 'Job', id: string, title: string, description: string, salaryMin: number, salaryMax: number, location: string, experienceRequired: number, educationRequired?: string | null, employmentType: EmploymentType, postedDate: string, expirationDate: any, skillsRequired?: Array<string> | null }> };

export type CreateJobMutationVariables = Exact<{
  jobInput: JobInput;
}>;


export type CreateJobMutation = { __typename?: 'Mutation', createJob: { __typename?: 'Job', id: string, title: string, description: string, salaryMin: number, salaryMax: number, location: string, experienceRequired: number, educationRequired?: string | null, employmentType: EmploymentType, postedDate: string, expirationDate: any, skillsRequired?: Array<string> | null } };

export type FetchMyJobQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type FetchMyJobQuery = { __typename?: 'Query', fetchMyJob: { __typename?: 'Job', id: string, title: string, description: string, salaryMin: number, salaryMax: number, location: string, experienceRequired: number, educationRequired?: string | null, employmentType: EmploymentType, postedDate: string, expirationDate: any, skillsRequired?: Array<string> | null } };

export type UpdateJobMutationVariables = Exact<{
  jobId: Scalars['ID']['input'];
  jobInput: JobUpdateInput;
}>;


export type UpdateJobMutation = { __typename?: 'Mutation', updateJob: { __typename?: 'Job', id: string, title: string, description: string, salaryMin: number, salaryMax: number, location: string, experienceRequired: number, educationRequired?: string | null, employmentType: EmploymentType, postedDate: string, expirationDate: any, skillsRequired?: Array<string> | null } };

export type UpdateCompanyDetailMutationVariables = Exact<{
  companyDetailInput: CompanyDetailInput;
}>;


export type UpdateCompanyDetailMutation = { __typename?: 'Mutation', updateCompanyDetail: { __typename?: 'User', email: string, phone?: string | null, company?: { __typename?: 'CompanyDetail', phone?: string | null, name?: string | null, companySize?: string | null, companyCreationDate?: string | null, website?: string | null, country?: string | null, city?: string | null } | null } };

export const RegisterDocument = gql`
    mutation Register($registerInput: RegisterInput!) {
  register(registerInput: $registerInput) {
    token
    user {
      id
      email
      firstName
      lastName
      phone
      role
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterGQL extends Apollo.Mutation<RegisterMutation, RegisterMutationVariables> {
    document = RegisterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginDocument = gql`
    query Login($loginInput: LoginInput!) {
  login(loginInput: $loginInput) {
    token
    user {
      id
      email
      firstName
      lastName
      phone
      role
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginGQL extends Apollo.Query<LoginQuery, LoginQueryVariables> {
    document = LoginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($email: String!) {
  requestPasswordReset(email: $email)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RequestPasswordResetGQL extends Apollo.Mutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables> {
    document = RequestPasswordResetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetPasswordDocument = gql`
    mutation ResetPassword($resetPasswordInput: ResetPasswordInput!) {
  resetPassword(resetPasswordInput: $resetPasswordInput)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetPasswordGQL extends Apollo.Mutation<ResetPasswordMutation, ResetPasswordMutationVariables> {
    document = ResetPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendContactMessageDocument = gql`
    query sendContactMessage($contactInput: ContactInput!) {
  sendContactMessage(contactInput: $contactInput)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendContactMessageGQL extends Apollo.Query<SendContactMessageQuery, SendContactMessageQueryVariables> {
    document = SendContactMessageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchCurrentUserDocument = gql`
    query FetchCurrentUser {
  fetchCurrentUser {
    email
    firstName
    lastName
    fullName
    phone
    address
    country
    nationality
    gender
    city
    avatar
    about
    employments {
      id
      jobTitle
      company
      description
      country
      city
      startDate
      endDate
      isCurrentPosition
    }
    educations {
      id
      school
      level
      specialization
      startDate
      endDate
    }
    skills {
      id
      skill
      proficiency
    }
    company {
      phone
      name
      companySize
      companyCreationDate
      website
      country
      city
      about
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchCurrentUserGQL extends Apollo.Query<FetchCurrentUserQuery, FetchCurrentUserQueryVariables> {
    document = FetchCurrentUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserResumeDocument = gql`
    mutation UpdateUserResume($about: String!) {
  updateUserResume(about: $about) {
    about
    company {
      about
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserResumeGQL extends Apollo.Mutation<UpdateUserResumeMutation, UpdateUserResumeMutationVariables> {
    document = UpdateUserResumeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePersonalDetailsDocument = gql`
    mutation UpdatePersonalDetails($personalDetailsInput: PersonalDetailsInput!) {
  updatePersonalDetails(personalDetailsInput: $personalDetailsInput)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePersonalDetailsGQL extends Apollo.Mutation<UpdatePersonalDetailsMutation, UpdatePersonalDetailsMutationVariables> {
    document = UpdatePersonalDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddUserEducationDocument = gql`
    mutation AddUserEducation($education: UserEducationInput!) {
  addUserEducation(education: $education) {
    id
    school
    level
    specialization
    startDate
    endDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddUserEducationGQL extends Apollo.Mutation<AddUserEducationMutation, AddUserEducationMutationVariables> {
    document = AddUserEducationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserEducationDocument = gql`
    mutation UpdateUserEducation($education: UserEducationUpdateInput!, $educationId: ID!) {
  updateUserEducation(education: $education, educationId: $educationId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserEducationGQL extends Apollo.Mutation<UpdateUserEducationMutation, UpdateUserEducationMutationVariables> {
    document = UpdateUserEducationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveUserEducationDocument = gql`
    mutation RemoveUserEducation($educationId: ID!) {
  removeUserEducation(educationId: $educationId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveUserEducationGQL extends Apollo.Mutation<RemoveUserEducationMutation, RemoveUserEducationMutationVariables> {
    document = RemoveUserEducationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddUserEmploymentDocument = gql`
    mutation AddUserEmployment($employment: UserEmploymentInput!) {
  addUserEmployment(employment: $employment) {
    id
    jobTitle
    company
    description
    country
    city
    startDate
    endDate
    isCurrentPosition
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddUserEmploymentGQL extends Apollo.Mutation<AddUserEmploymentMutation, AddUserEmploymentMutationVariables> {
    document = AddUserEmploymentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserEmploymentDocument = gql`
    mutation UpdateUserEmployment($employment: UserEmploymentUpdateInput!, $employmentId: ID!) {
  updateUserEmployment(employment: $employment, employmentId: $employmentId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserEmploymentGQL extends Apollo.Mutation<UpdateUserEmploymentMutation, UpdateUserEmploymentMutationVariables> {
    document = UpdateUserEmploymentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveUserEmploymentDocument = gql`
    mutation RemoveUserEmployment($employmentId: ID!) {
  removeUserEmployment(employmentId: $employmentId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveUserEmploymentGQL extends Apollo.Mutation<RemoveUserEmploymentMutation, RemoveUserEmploymentMutationVariables> {
    document = RemoveUserEmploymentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddUserSkillDocument = gql`
    mutation AddUserSkill($skill: UserSkillInput!) {
  addUserSkill(skill: $skill) {
    id
    skill
    proficiency
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddUserSkillGQL extends Apollo.Mutation<AddUserSkillMutation, AddUserSkillMutationVariables> {
    document = AddUserSkillDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserSkillDocument = gql`
    mutation UpdateUserSkill($skill: UserSkillUpdateInput!, $skillId: ID!) {
  updateUserSkill(skill: $skill, skillId: $skillId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserSkillGQL extends Apollo.Mutation<UpdateUserSkillMutation, UpdateUserSkillMutationVariables> {
    document = UpdateUserSkillDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveUserSkillDocument = gql`
    mutation RemoveUserSkill($skillId: ID!) {
  removeUserSkill(skillId: $skillId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveUserSkillGQL extends Apollo.Mutation<RemoveUserSkillMutation, RemoveUserSkillMutationVariables> {
    document = RemoveUserSkillDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchJobsDocument = gql`
    query FetchJobs {
  fetchJobs {
    id
    title
    description
    salaryMin
    salaryMax
    location
    experienceRequired
    educationRequired
    employmentType
    postedDate
    expirationDate
    skillsRequired
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchJobsGQL extends Apollo.Query<FetchJobsQuery, FetchJobsQueryVariables> {
    document = FetchJobsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchMyJobsDocument = gql`
    query FetchMyJobs {
  fetchMyJobs {
    id
    title
    description
    salaryMin
    salaryMax
    location
    experienceRequired
    educationRequired
    employmentType
    postedDate
    expirationDate
    skillsRequired
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchMyJobsGQL extends Apollo.Query<FetchMyJobsQuery, FetchMyJobsQueryVariables> {
    document = FetchMyJobsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateJobDocument = gql`
    mutation CreateJob($jobInput: JobInput!) {
  createJob(jobInput: $jobInput) {
    id
    title
    description
    salaryMin
    salaryMax
    location
    experienceRequired
    educationRequired
    employmentType
    postedDate
    expirationDate
    skillsRequired
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateJobGQL extends Apollo.Mutation<CreateJobMutation, CreateJobMutationVariables> {
    document = CreateJobDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchMyJobDocument = gql`
    query FetchMyJob($jobId: ID!) {
  fetchMyJob(jobId: $jobId) {
    id
    title
    description
    salaryMin
    salaryMax
    location
    experienceRequired
    educationRequired
    employmentType
    postedDate
    expirationDate
    skillsRequired
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchMyJobGQL extends Apollo.Query<FetchMyJobQuery, FetchMyJobQueryVariables> {
    document = FetchMyJobDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateJobDocument = gql`
    mutation UpdateJob($jobId: ID!, $jobInput: JobUpdateInput!) {
  updateJob(jobId: $jobId, jobInput: $jobInput) {
    id
    title
    description
    salaryMin
    salaryMax
    location
    experienceRequired
    educationRequired
    employmentType
    postedDate
    expirationDate
    skillsRequired
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateJobGQL extends Apollo.Mutation<UpdateJobMutation, UpdateJobMutationVariables> {
    document = UpdateJobDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompanyDetailDocument = gql`
    mutation updateCompanyDetail($companyDetailInput: CompanyDetailInput!) {
  updateCompanyDetail(companyDetailInput: $companyDetailInput) {
    email
    phone
    company {
      phone
      name
      companySize
      companyCreationDate
      website
      country
      city
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompanyDetailGQL extends Apollo.Mutation<UpdateCompanyDetailMutation, UpdateCompanyDetailMutationVariables> {
    document = UpdateCompanyDetailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }